<template>
  <main class="c-section--panel-courses c-section--speciality py-2">
    <div class="d-flex justify-content-start">
      <router-link to="/" class="c-link c-link--black d-flex align-items-center fs-18 mb-4">
        <i class="iconf-left-arrow d-flex align-items-center me-2"></i>
        Volver a mis cursos
      </router-link>
    </div>

    <div class="c-card-summary d-flex mb-5" :class="{'completed' : specStatus.type === 3}">
      <div>
        <div
          class="position-relative d-none
            d-md-block br--medium overflow-hidden">

          <b-skeleton-wrapper :loading="courses.loading">
            <template #loading>
              <div class="c-card-summary__cover">
                <div class="br--medium">
                  <b-skeleton
                    no-aspect
                    width="100%"
                    height="200px"
                    animation="fade"
                    class="light"
                  ></b-skeleton>
                </div>
              </div>
            </template>

            <figure class="c-card-summary__cover d-block">
              <img
                class="w-100 h-100 of--cover"
                :src="base.cover"
                alt="">
            </figure>

            <div class="c-card-summary__actions position-absolute">
              <button v-if="false" class="c-link c-link--white me-2">
                <div class="iconf-star"></div>
              </button>

              <Dropdown v-model="actions.switcher" class="c-more-actions">
                <template v-slot:toggle>
                  <button
                    @click="actions.switcher = !actions.switcher"
                    class="c-more-actions__button"
                  >
                    <div class="d-flex">
                      <Icon icon="uiw:setting" class="fs-18 me-1" />
                      <Icon icon="ant-design:caret-down-filled" class="fs-18" />
                    </div>
                  </button>
                </template>
                <template v-slot:menu>
                  <ul>
                    <li>
                      <button
                        @click="hide()"
                        :disabled="actions.isLoading"
                        class="c-more-actions__item d-flex"
                      >
                        <Icon :icon="hideButton.icon" class="fs-18 me-2" />
                        <span class="fs-14 w-sbold">
                          {{ hideButton.label }}
                        </span>
                      </button>
                    </li>
                    <li color="alert">
                      <button
                        @click="unenroll()"
                        :disabled="actions.isLoading"
                        class="c-more-actions__item d-flex">
                        <Icon icon="ci:trash-full" class="fs-18 me-2" />
                        <span class="fs-14 w-sbold">Eliminar</span>
                      </button>
                    </li>
                  </ul>
                </template>
              </Dropdown>
            </div>
          </b-skeleton-wrapper>
        </div>
      </div>
      <div class="ps-md-3 flex-grow-1">
        <div class="position-relative d-flex d-md-none justify-content-end align-items-center mb-3">
          <button v-if="false" class="c-link c-link--white me-2">
            <div class="iconf-star"></div>
          </button>

          <Dropdown v-model="actions.switcher" class="c-more-actions position-relative">
            <template v-slot:toggle>
              <button @click="actions.switcher = !actions.switcher" class="c-more-actions__button">
                <div class="d-flex">
                  <Icon icon="uiw:setting" class="fs-18 me-1" />
                  <Icon icon="ant-design:caret-down-filled" class="fs-18" />
                </div>
              </button>
            </template>
            <template v-slot:menu>
              <ul>
                <li>
                  <button
                    @click="hide()"
                    :disabled="actions.isLoading"
                    class="c-more-actions__item d-flex"
                  >
                    <Icon :icon="hideButton.icon" class="fs-18 me-2" />
                    <span class="fs-14 w-sbold">
                      {{ hideButton.label }}
                    </span>
                  </button>
                </li>
                <li color="alert">
                  <button
                    @click="unenroll()"
                    :disabled="actions.isLoading"
                    class="c-more-actions__item d-flex">
                    <Icon icon="ci:trash-full" class="fs-18 me-2" />
                    <span class="fs-14 w-sbold">Eliminar</span>
                  </button>
                </li>
              </ul>
            </template>
          </Dropdown>
        </div>

        <b-skeleton-wrapper :loading="courses.loading">
          <template #loading>
            <div class="c-card-summary__title">
              <div class="br--medium">
                <b-skeleton
                  no-aspect
                  height="50px"
                  animation="fade"
                  class="light mb-2"
                ></b-skeleton>
              </div>
              <div class="br--medium">
                <b-skeleton
                  no-aspect
                  animation="fade"
                  class="light"
                ></b-skeleton>
              </div>
            </div>
          </template>

          <div class="c-card-summary__title">
            <div class="d-flex mb-3 align-items-start">
              <h4 class="fs-21 w-bold mb-0">
                {{ base.title }}
              </h4>
              <div class="ps-3">
                <div class="c-card-course-player__badge rounded
                  ax-shadow center d-flex
                  justify-content-center align-items-center">
                  <i class="iconf-medal fs-21"></i>
                </div>
              </div>
            </div>

            <div>
              <p
                v-if="specStatus.type === 1 || specStatus.type === 2"
                class="fs-16 pri-alt w-sbold mb-0"
              >
                {{specStatus.description}}
              </p>

              <div v-if="specStatus.type === 3" class="d-flex align-items-center">
                <div class="c-card-course-player__ok rounded bg-pri-color white d-flex
                  justify-content-center align-items-center">
                  <i class="iconf-ok d-flex align-items-center"></i>
                </div>
                <span class="ms-2 fs-16 pri-alt w-sbold">Especialidad completada</span>
              </div>

              <Progress
                class="c-progress-bar--gray mt-1"
                :percentage="base.progress.percentage"
                :isSingle="true" />
            </div>

            <a
              v-if="base.certificate && base.certificate.path"
              :href="base.certificate.path"
              target="_blank"
              download
              class="c-button c-button--primary-ghost d-block text-center small mt-4 w-100">
              <Icon icon="akar-icons:download" class="fs-18 me-2" />
              Descargar certificado
            </a>
          </div>
        </b-skeleton-wrapper>
      </div>
    </div>

    <section>
      <div class="d-flex">
        <div class="mb-4">
          <h2 class="w-bold fs-21 mb-1">Cursos incluidos</h2>

          <b-skeleton-wrapper :loading="courses.loading">
            <template #loading>
              <b-skeleton
                no-aspect
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
            </template>

            <p class="mb-0 w-sbold fs-14">{{ courses.total }} cursos</p>
          </b-skeleton-wrapper>
        </div>
      </div>

      <b-skeleton-wrapper :loading="courses.loading">
        <template #loading>
          <div class="c-courses-grid">
            <div
              v-for="item of Array.from(Array(rows).keys())"
              :key="`course-skeleton-${item}`"
              class="c-courses-grid__item"
            >
              <div class="br--medium overflow-hidden">
                <b-skeleton
                  no-aspect
                  height="300px"
                  animation="fade"
                  class="light mb-2"
                ></b-skeleton>
              </div>
            </div>
          </div>
        </template>

        <div v-if="courses.isEmpty"  class="bg-white br--small p-3 py-md-4 text-center w-100">
          <p class="mb-3 w-medium">Error al cargar los cursos de la especialidad</p>
          <router-link
            to="/"
            class="c-link d-inline-block">
            <i class="iconf-left-arrow me-2"></i>
            Volver a mis cursos
          </router-link>
        </div>
        <section v-else>
          <div class="c-courses-grid">
            <div v-for="course of courses.data" :key="course.id" class="c-courses-grid__item">
              <CourseCard
                :body="course"
                :user="userData"
                :spec="true"
                :list.sync="courses.data"
                :total.sync="courses.total"
                :empty.sync="courses.isEmpty" />
            </div>
          </div>
        </section>
      </b-skeleton-wrapper>
    </section>
  </main>
</template>

<script>
import { mapState } from 'vuex';
import { Icon } from '@iconify/vue2';

export default {
  data() {
    return {
      rows: 3,

      actions: {
        switcher: false,
        isLoading: false,
      },

      base: {
        title: '',
        cover: false,
        progress: {},
        certificate: null,
        hide: false,
      },

      courses: {
        total: 0,
        data: [],
        isEmpty: false,

        loading: true,
      },
    };
  },
  components: {
    Icon,
    CourseCard: () => import(/* webpackChunkName: "course-card-player" */'../components/panel/CourseCard.vue'),
    Progress: () => import(/* webpackChunkName: "progress-bar" */'../components/ProgressBar.vue'),
    Dropdown: () => import(/* webpackChunkName: "dropdown" */'../components/ui/Dropdown.vue'),
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    specStatus() {
      let status = { label: '', type: -1 };

      if (this.base.progress) {
        const percentage = Number(this.base.progress.percentage);
        if (percentage === 0) {
          status = {
            type: 1,
            description: `${this.base.progress.advance}/${this.base.progress.total} cursos completados`,
          };
        } else if (percentage >= 100) {
          status = {
            type: 3,
          };
        } else {
          status = {
            type: 2,
            description: `${this.base.progress.advance}/${this.base.progress.total} cursos completados`,
          };
        }
      }

      return status;
    },
    hideButton() {
      return {
        label: (this.base.hide) ? 'Mostrar' : 'Ocultar',
        icon: (this.base.hide) ? 'bi:eye-fill' : 'bi:eye-slash-fill',
      };
    },
  },
  watch: {
    $route() {
      this.getContent();
    },

    userData(data) {
      this.user = data;

      this.getContent();
    },
    rows() {
      this.getContent();
    },
  },
  mounted() {
    this.user = this.userData;

    this.getContent();
  },
  methods: {
    getCourses() {
      const request = `${window.arcux.api}/profile/${this.user.id}/specialities/${this.$route.params.speciality_id}`;

      this.courses.loading = true;
      this.courses.isEmpty = false;

      fetch(request, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.base = {
              title: response.data.title,
              cover: response.data.cover,
              hide: response.data.hide,
              progress: response.data.progress,
              certificate: response.data.certificate,
            };
          }

          if (response.status && response.data.courses.length) {
            this.courses.data = response.data.courses;

            this.courses.total = response.data.courses.length;
            this.courses.loading = false;
          } else {
            this.$router.push('/');
          }
        })
        .catch(() => {
          this.$router.push('/');
        });
    },
    getContent() {
      this.courses = {
        ...this.courses,
        total: 0,
        data: [],
      };

      if (this.user && this.user.id) {
        this.getCourses();
      }
    },

    getProductREST(operation) {
      return `${window.arcux.api}/profile/${this.user.id}/products/${this.$route.params.speciality_id}/${operation}`;
    },
    hide() {
      const request = this.getProductREST('hide');

      this.actions.isLoading = true;

      fetch(request, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.base.hide = !this.base.hide;
          }

          this.actions.isLoading = false;
        })
        .catch(() => {
          this.actions.isLoading = false;
        });
    },
    unenroll() {
      const request = this.getProductREST('remove');

      this.actions.isLoading = true;

      fetch(request, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then(() => {
          this.$router.push('/');
        })
        .catch(() => {
          this.actions.isLoading = false;
        });
    },
  },
};
</script>
